import React, {Component} from "react"
import BannerSalonVideo from '../components/BannerSalonVideo'

class BannerMain extends Component{
	render(){
		return(
			<section className="banner-salon">
				<div className="inner">
					<div className="container">
						<div className="row">
							<div className="col-lg-7">
								<h1 className="titulo">
									<small>Salón</small>
									<span>{this.props.titulo}</span>
								</h1>
								<div className="capacidad">
									<span>Capacidad</span>
									<p>{this.props.capacidad}</p>
								</div>
								<BannerSalonVideo className="video-modal" videosrc={this.props.children} buttonLabel="Ver Video"></BannerSalonVideo>
							</div>
						</div>
					</div>
				</div>
				{/* <img className="poster" src={this.props.bgsrc} alt={this.props.titulo} width="2160" height="997"/> */}
				<video className="poster" width="1280" height="720" autoPlay loop muted playsInline>
					<source src={this.props.bgsrc} type="video/mp4"/>
				</video>
			</section>
		)
	}
}

export default BannerMain
